import React, { useEffect } from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import styles from "../../styles/CreateAccount.module.scss";
import VerifyViewIcon from "../../icons/VerifyViewIcon";
import { getQueryParamsFromUrl } from "../../utils/helpers";
import * as actions from "../../redux/actions";
import { MessageTile } from "@suralink/samurai/ui";
import { Alert } from "@suralink/samurai/icons";

interface StateProps {
  resendVerificationEmailStatus: number;
  createAccountInfo: any;
}

interface DispatchProps {
  resendEmailVerificationEmailAction: (
    email: string,
    clientId: string,
    redirectUri: string
  ) => any;
  getCreateAccountInfoAction: (inviteId: string) => any;
}

type Props = StateProps & DispatchProps & RouteComponentProps;

const VerifyAccountCard: React.FC<Props> = ({
  resendEmailVerificationEmailAction,
  getCreateAccountInfoAction,
  resendVerificationEmailStatus,
  createAccountInfo,
  history,
}) => {
  const { inviteId, email, clientId, redirectUri } = getQueryParamsFromUrl(
    window.location.href
  );

  useEffect(() => {
    inviteId && getCreateAccountInfoAction(inviteId);
  }, [getCreateAccountInfoAction, inviteId]);

  // if critical account info is missing send them to suralink.com
  useEffect(() => {
    if (!createAccountInfo.id) {
      return;
    }
    if (
      !createAccountInfo.clientId ||
      !createAccountInfo.redirectUri ||
      !createAccountInfo.email
    ) {
      window.location.href = "https://www.suralink.com";
    }
    return;
  }, [createAccountInfo]);

  useEffect(() => {
    if (resendVerificationEmailStatus === 409) {
      history.push(
        `/login?clientId=${createAccountInfo.clientId}&redirectUri=${createAccountInfo.redirectUri}`
      );
    }
  });

  return (
    <div className={styles.verifyMain}>
      <div className={styles.centerItems}>
        {resendVerificationEmailStatus === 201 ? (
          <MessageTile
            state="alert"
            message="We have sent you a new link to verify your account. Please check your email."
            style={{
              width: "550px",
              margin: "0 0 16px 0",
            }}
            icon={<Alert />}
            dismissAlertCb={() => {}}
            showDismiss={false}
          />
        ) : null}
        <div className={styles.verifyAccountCard}>
          <div
            style={{
              display: "flex",
            }}
          >
            <div className={styles.verifyText}>
              <h1>Welcome! We take your security seriously.</h1>
              <p>
                Please click on the link we've emailed to you to verify your
                account.
              </p>
            </div>

            <div className={styles.icon}>
              <VerifyViewIcon />
            </div>
          </div>
          <div className={styles.bottom}>
            <hr />
            <p>
              It may take a minute to receive your email. Haven’t received it?
              <span
                style={{ color: "#52ACFF", cursor: "pointer" }}
                onClick={() => {
                  resendEmailVerificationEmailAction(
                    createAccountInfo.email || email,
                    createAccountInfo.clientId || clientId,
                    createAccountInfo.redirectUri || redirectUri
                  );
                }}
              >
                &nbsp;Send new email.
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const mstp = (state: InitialStateModel): StateProps => {
  const { resendVerificationEmailStatus, createAccountInfo } = state;
  return {
    resendVerificationEmailStatus,
    createAccountInfo,
  };
};

const matp = ((): DispatchProps => {
  const { resendEmailVerificationEmailAction, getCreateAccountInfoAction } =
    actions;
  return {
    resendEmailVerificationEmailAction,
    getCreateAccountInfoAction,
  };
})();

export default connect(mstp, matp)(VerifyAccountCard);
